import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RISORSA } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlRisorsaState extends EntityState<IID_OL_RISORSA, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_RISORSA })
@InterfaceDataStore(InterfaceName.OLO_RISORSA)
export class IIDolRisorsaStore extends EntityStore<IIdOlRisorsaState> {
  constructor() {
    super([]);
  }
}